import { AppConfigModel } from '@/models/app/app-config';
import { appConfigSerializer } from '@/providers/serializers/app/app-config';
import { sessionService } from '@/providers/services/auth/session';

export class AppConfigService {

  private static INSTANCE = new AppConfigService();

  static get instance() {
    return this.INSTANCE;
  }

  private get session() {
    return sessionService.getSession();
 }

  private APP_CONFIG: string = 'MC_APP_CONFIG';

  private APP_USER_ROLE: string = 'MC_APP_USER_ROLE';

  private APP_USER_GROUP_LEVEL: string = 'MC_APP_USER_GROUP_LEVEL';

  public getTenantUrl() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.tenantUrl ? appConfig.tenantUrl : null;
  }

  public getAdminUiAppId() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.adminUiAppId ? appConfig.adminUiAppId : null;
  }

  public getNavigatorBasePath() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.S3_BUCKET_ASSETS_BASE_PATH ? appConfig.S3_BUCKET_ASSETS_BASE_PATH : null;
  }

  public getStaticImageUrl() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.STATIC_IMAGE_URL ? appConfig.STATIC_IMAGE_URL : null;
  }

  public setAppConfig(appConfigModel: AppConfigModel) {
    localStorage.setItem(this.APP_CONFIG, JSON.stringify(appConfigModel));
  }

  public setAppUserRole(userRole: any) {
    localStorage.setItem(this.APP_USER_ROLE, JSON.stringify(userRole));
  }

  public isDemoTenant() {
    const appConfig = this.getAppConfig();
    return appConfig && this.session && this.session.username && appConfig.demo_tenant.includes(this.session.username);
  }

  public getLanguages() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.language ? appConfig.language : [];
  }

  public getAppId() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.appId ? appConfig.appId : null;
  }

  public getLoginPageInfo() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.loginPageInfo ? appConfig.loginPageInfo : null;
  }

  public getAppUserRole() {
    let role = null;
    const userRole = localStorage.getItem(this.APP_USER_ROLE);
    if ( userRole ) {
      role = JSON.parse(userRole);
    }
    return role;
  }

  public setUserGroupAccessLevel(groupLevels: any) {
    localStorage.setItem(this.APP_USER_GROUP_LEVEL, JSON.stringify(groupLevels));
  }

  public getUserGroupAccessLevel() {
    const groupLevel = localStorage.getItem(this.APP_USER_GROUP_LEVEL);
    if (groupLevel) {
      return JSON.parse(groupLevel);
    }
    return null;
  }

  public getContentProviders() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.content_providers ? appConfig.content_providers : [];
  }

  public getProvidersList() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.provider_tools ? appConfig.provider_tools : [];
  }

  public getApiUrl() {
    const appConfig = this.getAppConfig();
    return appConfig ? appConfig.api_endpoint_url : process.env.VUE_APP_API_URL;
    // return process.env.VUE_APP_API_URL;
  }

  public getClientId() {
    return process.env.VUE_APP_CLIENT_ID;
  }

  public getClientKey() {
    return process.env.VUE_APP_CLIENT_KEY;
  }

  public isStaging() {
    const appConfig = this.getAppConfig();
    return appConfig!.is_stage_drill_down;
  }

  private getAppConfig() {
    let appConfig = null;
    const appConfigAsString: string | null = localStorage.getItem(this.APP_CONFIG);
    if (appConfigAsString) {
      const appConfigAsJson = JSON.parse(appConfigAsString);
      appConfig = appConfigSerializer.appConfigModelSerializer(appConfigAsJson);
    }
    return appConfig;
  }

}

export const appConfigService = AppConfigService.instance;
